export default __webpack_public_path__ + "static/media/puzzleClue1.598f9c0d.png";